/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bms_Open_In_New_TabInputs */



/**
* | output |
* | --- |
* | "Open in a new tab" |
*
* @param {Bms_Open_In_New_TabInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const bms_open_in_new_tab = /** @type {((inputs?: Bms_Open_In_New_TabInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bms_Open_In_New_TabInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Open in a new tab")
	return /** @type {LocalizedString} */ ("Ouvrir dans un nouvel onglet")
});